import type { PriceBreakdown } from "@/domain/model/PriceBreakdown";
import type { PricingService } from "@/domain/port/PricingService";

export class PricingServiceImpl implements PricingService {
  constructor(
    private readonly pricePerSeatNetCents: number,
    private readonly vatRate: number,
  ) {}

  calculateMonthlySeats(seatCount: number): PriceBreakdown {
    const net = this.pricePerSeatNetCents * seatCount;
    const vat = Math.round(net * this.vatRate);
    const gross = net + vat;

    return {
      seatCount,
      netCents: net,
      vatCents: vat,
      grossCents: gross,
      vatRate: this.vatRate,
      pricePerSeatNetCents: this.pricePerSeatNetCents,
    };
  }
}
